// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NBUm","largestCol":"styles_largestCol__qH5Tx","smallestCol":"styles_smallestCol__oXnQ9"};